<template>
  <b-modal
    ref="modal-labor-regime-payroll"
    hide-footer
    size="sm"
    no-close-on-backdrop
    @hidden="onlyClose"
    :title="optionModal == 1 ? $t('add labor regime') : $t('edit labor regime') | capitalize"
  >
    <template #default>
      <validation-observer ref="form">
        <b-form-group
          :label="$t('name') | capitalize"
          label-for="to"
          style="width: 100%"
          ><validation-provider v-slot="{ errors }" rules="required">
            <b-form-input
              id="comment"
              v-model="laborRegime.name"
              :class="{ 'border-danger': errors[0] }"
            />
          </validation-provider>
        </b-form-group>
        <b-form-group
          :label="$t('holidays quantity') | capitalize"
          label-for="to"
          style="width: 100%"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <b-form-input
              id="comment"
              type="number"
              v-model="laborRegime.holidays"
              :class="{ 'border-danger': errors[0] }"
              :disabled="optionModal == 2"
            />
          </validation-provider>
        </b-form-group>
        <!-- <b-form-group :label="$t('COMMENT')" label-for="to" style="width: 100%">
          <b-form-input id="comment" />
        </b-form-group>

        <b-form-group
          :label="$t('DRIVER COMMENT')"
          label-for="to"
          style="width: 100%"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <b-form-textarea
              id="comment"
              class="input-form observer"
              :class="{ 'border-danger': errors[0] }"
              no-resize
              size="lg"
            />
          </validation-provider>
        </b-form-group> -->
        <div class="d-flex justify-content-end" style="width: 100%">
          <b-button variant="outline-danger" size="sm" @click="onlyClose">
            {{ $t("close") | capitalize }}
          </b-button>
          <b-button
            variant="outline-primary"
            class="ml-1"
            size="sm"
            @click="submitForm"
          >
            {{  optionModal == 1 ? $t("save") : $t("edit") | capitalize}}
          </b-button>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>
import LaborRegimeService from "@/views/settings/views/payroll/components/labor-regime/service/labor-regime-service.js";
import { mapGetters } from "vuex";
export default {
  props: {
    labor: {
      type: Object,
      required: false,
    },
    optionModal: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      userId: "auth/currentUser",
    }),
  },
  data() {
    return {
      laborRegime: this.labor ? Object.assign({}, this.labor) : null,
    };
  },
  mounted() {
    this.toggleModal("modal-labor-regime-payroll");
  },

  methods: {
    onlyClose() {
      this.$emit("onlyClose");
    },
    closeRefresh() {
      this.$emit("closeReload");
    },

    async submitForm() {
      const isValidMessage = await this.$refs.form.validate();
      if (isValidMessage) {
        try {
          this.addPreloader();
          const params = {
            name: this.laborRegime.name,
            holidays: this.laborRegime.holidays,
            created_by: this.userId.id,
            id: this.laborRegime.id,
            option: this.optionModal,
          };
          const { data } = await LaborRegimeService.insertOrUpdateLaborRegime(
            params
          );
        } catch (error) {
          console.log(error);
          this.showToastError();
        } finally {
          this.closeRefresh();
          this.removePreloader();
        }
      }
    },
  },
};
</script>

<style>
</style>